"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthType = exports.authTypes = void 0;
var _jsTools = require("@airportlabs/js-tools");
var authTypes = exports.authTypes = {
  FULL: "FULL",
  SIMPLE: "SIMPLE",
  NONE: "NONE"
};
var getAuthType = exports.getAuthType = function getAuthType() {
  var ENV_VAR = (0, _jsTools.getEnv)("REACT_APP_AUTH_TYPE", {
    isRequired: false
  });
  return Object.values(authTypes).includes(ENV_VAR) ? ENV_VAR : authTypes.FULL;
};